/*=========================================================================================
  File Name: moduleExpenseSettingActions.js
  Description: ExpenseSetting Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';
import { PaymentEntityModel } from '../../../models/EntityModels/PaymentEntityModel';

export default {
  async AddPayment({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `expenses/${Credentials.expenseId}/payments`,
          new PaymentEntityModel(Credentials),
        )
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
